export const getAudioProgress = (audioRef: React.RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		const length = getAudioLengthMs(audioRef);
		if (length === 0) {
			return 0;
		}

		return Math.floor((getAudioCurrentTimeMs(audioRef) / length) * 100);
	}

	return 0;
};

export const getAudioLengthMs = (audioRef: React.RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		const duration = audioRef.current.duration;
		if (isNaN(duration) || duration === Infinity) {
			return 0;
		}

		return Math.floor(duration * 1000);
	}

	return 0;
};

export const getAudioCurrentTimeMs = (audioRef: React.RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		return Math.floor(audioRef.current.currentTime * 1000);
	}

	return 0;
};
